import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TransferState } from '@angular/core';

import {
  MissingTranslationHandler,
  MissingTranslationHandlerParams,
  TranslateCompiler,
  TranslateLoader,
  TranslateModule
} from '@ngx-translate/core';
import { HostNameInterpolationCompiler } from '@cakeiteasy/web-utils';

import { TranslatesService } from '../translates.service';
import { TranslatesBrowserLoaderService } from './translates-browser-loader.service';
import { LocationManagerService } from '@cakeiteasy/web-utils';

export function translateStaticLoader(http: HttpClient, transferState: TransferState,
                                      locationManager: LocationManagerService): TranslatesBrowserLoaderService {
  return new TranslatesBrowserLoaderService('/assets/i18n/', 'countries/',
    'references/', 'marketplace/', '.json', transferState, http, locationManager);
}

export class MissingTranslationService implements MissingTranslationHandler {
  constructor() {
  }

  public handle(params: MissingTranslationHandlerParams) {
    return '';
  }
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: translateStaticLoader,
          deps: [HttpClient, TransferState, LocationManagerService]
        },
        missingTranslationHandler: {
          provide: MissingTranslationHandler,
          useClass: MissingTranslationService
        },
        compiler: {
          provide: TranslateCompiler,
          useClass: HostNameInterpolationCompiler
        }
      }
    ),
  ],
  providers: [TranslatesService]
})
export class TranslatesBrowserModule {
}
